module.exports = __webpack_public_path__ + "img/5V.1a6b986d.png";